module.exports = __webpack_public_path__ + "img/timer@2x.33af7db2.png";